import { render, staticRenderFns } from "./to-develop.vue?vue&type=template&id=713189e0&lang=html&"
import script from "./to-develop.vue?vue&type=script&lang=js&"
export * from "./to-develop.vue?vue&type=script&lang=js&"
import style0 from "./to-develop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "to-develop.vue"
export default component.exports